module.exports = __webpack_public_path__ + "img/bus-passengers.4f51d66e.webp";